import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { userLogout } from "../../../Redux/actions";
import UserInterface from "../InnerLayout/UserInterface";

const SWInterface = ({ children, step = 0, selectPriceContainer = null }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer.user_details);
  return (
    <UserInterface noNav={true}>
      <div className="custom_design wizard_ms pb-5">
        <section className="account-wizzer">
          <div className="row_count">
            <div className="statistic clearfix hidden-print finance-page pt-4">
              <div className="current_page pull_left">
                <div className="logo-sec now-width d-flex w-100">
                  <img className="logo-img" src="/img/gogmgo_wizard_logo.svg" />

                  <a onClick={() => dispatch(userLogout())}>
                    <button className="btn bordered-btn btn-lg mx-0">
                      Finish later
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="custom_row_cotnent">
            <div className="steps-finance">
              <div className="step-wiz-parent col-md-4">
                {user?.merchant?.parent_merchant_id == 0 ? (
                  <ul className="steps-li px-0">
                    {/* parent */}
                    <li className="first_Csutom">
                      <h4 className="event-alert">Onboarding Journey </h4>
                    </li>
                    <li>
                      <a
                        href="#step0"
                        id="step0show"
                        className={`step0show${step > 0 ? " filled" : ""}${
                          step == 0 ? " active" : ""
                        }`}
                      >
                        <span>1</span> Pick Your Solution
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step1"
                        id="step1show"
                        className={`step1show ${step > 1 ? " filled" : ""}${
                          step == 1 ? " active" : ""
                        }`}
                      >
                        <span>2</span> Account Details
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step2"
                        id="step3show"
                        className={`step2show ${step > 2 ? " filled" : ""}${
                          step == 2 ? " active" : ""
                        }`}
                      >
                        <span>3</span> Business Settings
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step3"
                        id="step4show"
                        className={`step3show ${step > 3 ? " filled" : ""}${
                          step == 3 ? " active" : ""
                        }`}
                      >
                        <span>4</span> Labor Settings
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step4"
                        id="step5show"
                        className={`step4show ${step > 4 ? " filled" : ""}${
                          step == 4 ? " active" : ""
                        }`}
                      >
                        <span>5</span> Staff Upload
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step5"
                        id="step6show"
                        className={`step5show ${step > 5 ? " filled" : ""}${
                          step == 5 ? " active" : ""
                        }`}
                      >
                        <span>6</span> Payment Accounts
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step6"
                        id="step7show"
                        className={`step6show ${step > 6 ? " filled" : ""}${
                          step == 6 ? " active" : ""
                        }`}
                      >
                        <span>7</span> Payee Upload
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step7"
                        id="step8show"
                        className={`step7show ${step > 7 ? " filled" : ""}${
                          step == 7 ? " active" : ""
                        }`}
                      >
                        <span>8</span> User Account Setup
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step8"
                        id="step9show"
                        className={`step8show ${step > 8 ? " filled" : ""}${
                          step == 8 ? " active" : ""
                        }`}
                      >
                        <span>9</span> Onlife Setup
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step9"
                        id="step10show"
                        className={`step9show ${step > 9 ? " filled" : ""}${
                          step == 9 ? " active" : ""
                        }`}
                      >
                        <span>10</span> Let's Get Balanced &amp; Go
                      </a>
                    </li>
                  </ul>
                ) : (
                  <ul className="steps-li px-0">
                    {/* child */}
                    <li className="first_Csutom">
                      <h4 className="event-alert">Onboarding Journey </h4>
                    </li>
                    <li>
                      <a
                        href="#step0"
                        id="step0show"
                        className={`step0show${step > 0 ? " filled" : ""}${
                          step == 0 ? " active" : ""
                        }`}
                      >
                        <span>1</span> Pick Your Solution
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step1"
                        id="step1show"
                        className={`step1show ${step > 1 ? " filled" : ""}${
                          step == 1 ? " active" : ""
                        }`}
                      >
                        <span>2</span> Account Details
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step2"
                        id="step3show"
                        className={`step2show ${step > 2 ? " filled" : ""}${
                          step == 2 ? " active" : ""
                        }`}
                      >
                        <span>3</span> Business Settings
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step4"
                        id="step5show"
                        className={`step4show ${step > 4 ? " filled" : ""}${
                          step == 4 ? " active" : ""
                        }`}
                      >
                        <span>4</span> Staff Upload
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step7"
                        id="step8show"
                        className={`step7show ${step > 7 ? " filled" : ""}${
                          step == 7 ? " active" : ""
                        }`}
                      >
                        <span>5</span> User Account Setup
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step8"
                        id="step9show"
                        className={`step8show ${step > 8 ? " filled" : ""}${
                          step == 8 ? " active" : ""
                        }`}
                      >
                        <span>6</span> Onlife Setup
                      </a>
                    </li>
                    <li>
                      <a
                        href="#step9"
                        id="step10show"
                        className={`step9show ${step > 9 ? " filled" : ""}${
                          step == 9 ? " active" : ""
                        }`}
                      >
                        <span>7</span> Let's Get Balanced &amp; Go
                      </a>
                    </li>
                  </ul>
                )}
              </div>

              {children}
            </div>
            {step == 0 && selectPriceContainer}
          </div>
        </section>
      </div>
    </UserInterface>
  );
};
export default SWInterface;
